import { useCallback, useEffect, useRef } from 'react';
import { ModalProps } from '../ui/modal/modal.props';

export const useModal = ({ isOpen, onClose }: Pick<ModalProps, 'isOpen' | 'onClose'>) => {
	const dialogRef = useRef<HTMLDialogElement>(null);
	const contentRef = useRef<HTMLDivElement>(null);

	const handleClose = useCallback(
		(event: MouseEvent) => {
			if (!contentRef.current?.contains(event.target as Node)) {
				onClose();
			}
		},
		[onClose],
	);

	useEffect(() => {
		if (!dialogRef.current) {
			return;
		}

		if (isOpen) {
			dialogRef.current.showModal();
		} else {
			dialogRef.current.close();
		}
	}, [isOpen]);

	useEffect(() => {
		if (!isOpen) {
			return;
		}

		document.addEventListener('mousedown', handleClose, false);

		return () => {
			document.removeEventListener('mousedown', handleClose, false);
		};
	}, [isOpen, handleClose]);

	return {
		dialogRef,
		contentRef,
	};
};
